/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * metapic-api
 * Metapic API
 * OpenAPI spec version: 0.0.1
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type { UserTagsIndex200, UserTagsIndexParams } from '../metapicApi.schemas'

export const getUserTag = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * Endpoint for querying & sorting all user tags.
   * @summary List user tags
   */
  const userTagsIndex = (
    params?: UserTagsIndexParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<UserTagsIndex200>> => {
    return axiosInstance.get(`/v2/user-tags`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * @summary Store a newly created resource in storage
   */
  const userTagsStore = (options?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
    return axiosInstance.post(`/v2/user-tags`, undefined, options)
  }
  /**
   * @summary Display the specified resource
   */
  const userTagsShow = (id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
    return axiosInstance.get(`/v2/user-tags/${id}`, options)
  }
  /**
   * @summary Update the specified resource in storage
   */
  const userTagsUpdate = (
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.put(`/v2/user-tags/${id}`, undefined, options)
  }
  /**
   * @summary Remove the specified resource from storage
   */
  const userTagsDestroy = (
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void>> => {
    return axiosInstance.delete(`/v2/user-tags/${id}`, options)
  }
  return { userTagsIndex, userTagsStore, userTagsShow, userTagsUpdate, userTagsDestroy }
}
export type UserTagsIndexResult = AxiosResponse<UserTagsIndex200>
export type UserTagsStoreResult = AxiosResponse<void>
export type UserTagsShowResult = AxiosResponse<void>
export type UserTagsUpdateResult = AxiosResponse<void>
export type UserTagsDestroyResult = AxiosResponse<void>
